export const WEB = 'WEB';
export const PARTNER = 'PARTNER';
export const DROID = 'DROID';
export const MOB = 'MOB';
export const PACT = 'PACT';
